import { RightOutlined, SearchOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import TimeScheduleReport from "./TimeScheduleReport";
import commonService from "../../api/common.service";
import AllPaymentView from "../../components/report/AllPaymentView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import { PRINT_BASE_URL } from "../../utility/URL";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver'; // if using in browser

const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth(),
    receipt_end_date: commonUtility.lastDateOfMonth(),
    member_id: "",
};



const AllReceiptReport = () => {
    const [form] = Form.useForm();



    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [programmeList, setProgrammeList] = useState([]);
    const [paymentModeList, setPaymentModeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);
    const [modeName, setModeName] = useState("");

    const onFromDateChange = (date, dateString) => {
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            receipt_start_date: dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            receipt_end_date: dateString
        });

    };



    const onReportSearch = async (values) => {
        setReportList([])
        setFilteredSearchList([]);

        const formdValues = {
            payment_mode_id: values.programme_id == undefined ? '' : values.programme_id,
            from_date: values.receipt_start_date == undefined ? '' : values.receipt_start_date,
            to_date: values.receipt_end_date == undefined ? '' : values.receipt_end_date,
        }

        const data = { formData: formdValues };

        ProgrammeService.allPayment(data).then((res) => {
            if (res.data.response_status == SUCCESS_STATUS) {
                setReportList(res.data.response_data);
                setFilteredSearchList(res.data.response_data);
            }
            else {
                setReportList([])
                setFilteredSearchList([]);
            }
            setIsDataUpdated(!isDataUpdated)
        });
    };



    const onProgrammeChange = (id, object) => {
        console.log('onProgrammeChange', id, object);
        setModeName(object.children);
    }



    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                const filteredProgrammes = res.data.response_data.filter((item) =>
                    [1, 3, 4, 6].includes(item.programme_id)
                );
                setProgrammeList(filteredProgrammes);
            }
        });
    }, []);

    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            setPaymentModeList(res.data.response_data);
        });
    }, [])

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = reportList.filter((data) => Object.values(data).join('').replace(/\s/g, '').toLowerCase().includes(string.replace(/(\s+|to)/g, '').toLowerCase()));
        setFilteredSearchList(x)
    }

    const handleExcelAllReceipt = async () => {
        try {
            const values = await form.validateFields();
            const url_excel = 'gstregister/all_receipt_report';
            let url = buildExcelUrl(values, url_excel);
            commonUtility.openInNewTab(url);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    const formatDate = (dateStr) => {
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const buildExcelUrl = (values, url_first) => {
        let url = '';
        const formValues = {
            from_date: formatDate(values.receipt_start_date) || '',
            to_date: formatDate(values.receipt_end_date) || '',
            programme_id: values.programme_id || '0',
            enrollment_id: values.enrollment_id || '0',
            member_id: values.member_id || '0',
            gst_bill: values.gst_bill || ''
        };

        if (formValues.from_date !== "" && formValues.from_date !== "") {
            url = `${PRINT_BASE_URL}${url_first}/${formValues.from_date}/${formValues.to_date}/${formValues.programme_id}/${formValues.enrollment_id}/${formValues.member_id}/${formValues.gst_bill}`;
        }

        return url;
    };

    function disabledDate(current) {

        let sessionData = commonUtility.getLoggedInUserInfo();

        const startDate = new Date(sessionData.yearData.start_date); // Example start date
        const endDate = new Date(sessionData.yearData.end_date);   // Example end date

        endDate.setDate(endDate.getDate() + 1);

        return current < startDate || current > endDate;
    }

    const exportToExcel = async (data) => {
        // Step 1: Transform the data
        const transformedData = data.map(item => {
            return {
                Name: `${item.member_fname.trim()} ${item.member_lname.trim()}`,
                programme_name: item.programme_name,
                programme_group: item.programme_group,
                payment_no: item.payment_no,
                payment_date: item.payment_date,
                payment_amount: item.payment_amount,
            };
        });

        // Step 2: Create workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Payments');

        // Step 3: Define columns
        worksheet.columns = [
            { header: 'NAME', key: 'Name', width: 30 },
            { header: 'PROGRAMME NAME', key: 'programme_name', width: 25 },
            { header: 'PROGRAMME GROUP', key: 'programme_group', width: 20 },
            { header: 'PAYMENT NO', key: 'payment_no', width: 25 },
            { header: 'PAYMENT DATE', key: 'payment_date', width: 20 },
            { header: 'PAYMENT AMOUNT', key: 'payment_amount', width: 20 },
        ];

        // Step 4: Add data rows
        transformedData.forEach(row => worksheet.addRow(row));
        worksheet.getRow(1).font = { bold: true };

        // Step 5: Add one blank row
        worksheet.addRow([]);

        // Step 6: Calculate total payment amount
        const totalAmount = transformedData.reduce((sum, item) => sum + item.payment_amount, 0);

        // Step 7: Add total row
        const lastRowIndex = worksheet.lastRow.number + 1;
        const totalRow = worksheet.getRow(lastRowIndex);

        const labelColumnSpan = worksheet.columns.length - 1; // All columns except last one
        const lastColumnLetter = worksheet.getColumn(worksheet.columns.length).letter;

        // Merge cells for "Total Amount" label
        worksheet.mergeCells(`A${lastRowIndex}:${String.fromCharCode(64 + labelColumnSpan)}${lastRowIndex}`);
        totalRow.getCell(1).value = 'Total Amount';
        totalRow.getCell(1).alignment = { horizontal: 'left' };
        totalRow.getCell(1).font = { bold: true };

        // Set the total value in last column
        totalRow.getCell(worksheet.columns.length).value = totalAmount;
        totalRow.getCell(worksheet.columns.length).numFmt = '₹#,##0.00';
        totalRow.getCell(worksheet.columns.length).font = { bold: true };

        totalRow.commit();

        // Step 8: Generate and download file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Payment_Report_${selectedFromDate}_to_${selectedEndDate}_${modeName}.xlsx`);
    };

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="All Payment Report"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >


                                        <Col xs={24} xl={3} >
                                            <Form.Item
                                                name="from_date_picker"
                                                label="From Date"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select From Date',
                                                    },
                                                ]}
                                            >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    // defaultValue={moment(commonUtility.firstDateOfMonth(), DATE_FORMAT_DMY_SLASH)}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_start_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item
                                                name="to_date_picker"
                                                label="End Date"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select End Date',
                                                    },
                                                ]}
                                            >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    // defaultValue={moment(commonUtility.lastDateOfMonth(), DATE_FORMAT_DMY_SLASH)}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_end_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={4} xl={6}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Payment Mode"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select Payment Mode',
                                                    },
                                                ]}

                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }
                                                >
                                                    {paymentModeList.length > 0
                                                        ? paymentModeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.id}
                                                                value={programme_list.id}
                                                            // short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.payment_mode}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1} style={{ marginLeft: '10px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={() => exportToExcel(filteredSearchList)}
                                                >
                                                    <DownloadOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>


                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        <div className='tableView'>
                            <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                            <div className="form-content">
                                <AllPaymentView reportList={filteredSearchList} isDataUpdatedValue={isDataUpdated} setFilteredSearchList={setFilteredSearchList} memberList={memberList} />
                            </div>
                        </div>




                    </div>

                </div>
            </div>

        </div>


    )
}

export default AllReceiptReport